import { getProductionConfig } from './production';
import { getTestingEnvConfig } from './testingEnv';
import { getDevelopmentConfig } from './development';

export function isProduction() {
  window.location.host === 'www.tapresearch.com';
}

export type Environment = 'production' | 'testingEnv' | 'development';

export function getEnvironment(host = window.location.host) {
  if (host.match(/^.*\.tapresearch\.com$/)) {
    return host.includes('www') ? 'production' : 'testingEnv';
  } else {
    return 'development';
  }
}

interface RequestConfig {
  pollingInterval?: number;
}

export interface TapiConfig {
  mockRequests: boolean;
  requests: {
    healthStatus: RequestConfig;
    campaignAlerts: RequestConfig;
    matchesStats: RequestConfig;
    completesStats: RequestConfig;
    quotaStats: RequestConfig;
    campaignFieldingStats: RequestConfig;
  };
}

const FiveMinutes = 1 * 1000 * 60 * 5;

export const baseConfig: TapiConfig = {
  mockRequests: false,
  requests: {
    healthStatus: {
      pollingInterval: 30000,
    },
    campaignAlerts: {
      pollingInterval: FiveMinutes,
    },
    matchesStats: {
      pollingInterval: FiveMinutes,
    },
    completesStats: {
      pollingInterval: FiveMinutes,
    },
    quotaStats: {
      pollingInterval: FiveMinutes,
    },
    campaignFieldingStats: {
      pollingInterval: FiveMinutes,
    },
  },
};

export const getTapiConfig = () => {
  switch (getEnvironment()) {
    case 'production':
      return getProductionConfig(baseConfig);
    case 'testingEnv':
      return getTestingEnvConfig(baseConfig);
    case 'development':
      return getDevelopmentConfig(baseConfig);
    default:
      return baseConfig;
  }
};

declare global {
  interface Window {
    tapiConfig: TapiConfig;
  }
}

export const config = getTapiConfig();

export const setTapiConfig = () => {
  const tapiConfig = getTapiConfig();
  window.tapiConfig = tapiConfig;
};
